import React from 'react';

import { graphql } from 'gatsby';
import GridSectionDS from 'design-system/src/components/organisms/GridSection';

export default function GridNavigation3Section({
    images,
    values,
    ...props
}: any) {
    return <GridSectionDS {...props} variant="grid-navigation-3" />;
}

export const query = graphql`
    fragment DatoCmsGridNavigation3Section on DatoCmsGridNavigation3Section {
        items {
            title
            text
            cta {
                ...Button
            }
        }
    }
`;
